/**
 * Lightweight per-item currency utilities.
 *
 * Each Product, Trip, and Course has its OWN `currency` field set by the admin
 * (one of: ZAR, EUR, GBP, USD). The storefront simply displays the stored price
 * with the matching symbol — no conversion math.
 */

export const SUPPORTED_CURRENCIES = [
  { code: 'ZAR', symbol: 'R', label: 'ZAR — South African Rand (R)' },
  { code: 'EUR', symbol: '€', label: 'EUR — Euro (€)' },
  { code: 'GBP', symbol: '£', label: 'GBP — British Pound (£)' },
  { code: 'USD', symbol: '$', label: 'USD — US Dollar ($)' },
];

const SYMBOL_BY_CODE = Object.fromEntries(SUPPORTED_CURRENCIES.map((c) => [c.code, c.symbol]));

/** Returns the symbol for a currency code (defaults to R for ZAR / unknown). */
export const currencySymbol = (code) => SYMBOL_BY_CODE[code] || 'R';

/**
 * Format a numeric amount in the supplied currency.
 *   formatItemPrice(1999, 'EUR')                → "€1,999.00"
 *   formatItemPrice(1999, 'ZAR', { compact: true }) → "R1,999"
 *   formatItemPrice(null, 'ZAR')                → ""
 */
export const formatItemPrice = (amount, currency = 'ZAR', { compact = false } = {}) => {
  if (amount === null || amount === undefined || amount === '' || isNaN(amount)) return '';
  const sym = currencySymbol(currency);
  const decimals = compact ? 0 : 2;
  return `${sym}${Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
};
